import { Sentry } from '@/lib/sentry'

type ReportLevel = 'fatal' | 'error' | 'warning'

type ReportSource = 'render' | 'react-query' | 'unhandled' | 'payment-decline'

interface ReportErrorContext {
  source: ReportSource
  level?: ReportLevel
  componentStack?: string | null
  /** Sentry 이슈 그룹핑 키 — 예: PG 거절을 사유 code 별로 묶기 ['payment-decline', code] */
  fingerprint?: string[]
}

export function reportError(error: unknown, context: ReportErrorContext): void {
  const tag = `[GlobalErrorBoundary:${context.source}]`

  if (import.meta.env.DEV) {
    console.error(tag, error, {
      level: context.level ?? 'error',
      componentStack: context.componentStack,
    })
    return
  }

  // prod 콘솔 로깅 안 함 — Sentry.captureException 이 리포팅 담당.
  // (iOS WKWebView는 console 인자를 native로 postMessage 직렬화하는데 error 객체가
  //  비직렬화면 InvalidAccessError 발생 → prod 에선 애초에 console 로 안 넘김)
  Sentry.captureException(error, {
    level: context.level ?? 'error',
    tags: { source: context.source },
    contexts: {
      react: { componentStack: context.componentStack ?? null },
    },
    ...(context.fingerprint ? { fingerprint: context.fingerprint } : {}),
  })
}
